// @ts-strict-ignore
export class UserActionInfo {
  public actionName: string;
  public date: Date;
  public actionProperties: Object;

  public constructor(actionName: string = 'unknown', actionProperties: Object = null, date: Date = null) {
    this.actionName = actionName;
    this.date = date ? date : new Date();
    this.actionProperties = actionProperties ? actionProperties : {};
  }
}
